
export const AppMenus = {

  navbarTopRight: [],
  navbarTopLeft: [],
  navbarSideLeft: [
    {
      "to": "/home",
      "label": "Home",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/chats",
      "label": "Chats",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/clients",
      "label": "Clients",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/complaints",
      "label": "Complaints",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/complaintslist",
      "label": "Complaints List",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/customers",
      "label": "Customers",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/debitcards",
      "label": "Debit Cards",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/feedbacks",
      "label": "Feedbacks",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/feeds",
      "label": "Feeds",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/feedslist",
      "label": "Feeds List",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/gpsaddress",
      "label": "Gps Address",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/impressions",
      "label": "Impressions",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/managers",
      "label": "Managers",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/meters",
      "label": "Meters",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/notifications",
      "label": "Notifications",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/offices",
      "label": "Offices",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/pageshelpcenter",
      "label": "Pages Helpcenter",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/paymenthistory",
      "label": "Payment History",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/regiondistricts",
      "label": "Region Districts",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/reportrequests",
      "label": "Report Requests",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/userpermissions",
      "label": "User Permissions",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/userroles",
      "label": "User Roles",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/users",
      "label": "Users",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/activities",
      "label": "Activities",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/appdownloads",
      "label": "App Downloads",
      "icon": "pi pi-th-large",
      "iconcolor": "",
      "target": "",

    }
  ],
  participantType: [
    { value: "customer", label: "customer" },
    { value: "support", label: "support" },
    { value: "administrator", label: "administrator" },
    { value: "manager", label: "manager" },
    { value: "agent", label: "agent" }
  ],
  status: [
    { value: "sent", label: "sent" },
    { value: "read", label: "read" },
    { value: "unread", label: "unread" },
    { value: "pending", label: "pending" },
    { value: "success", label: "success" },
    { value: "failed", label: "failed" },
    { value: "ready", label: "ready" }
  ],
  expiry_month: [
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" }
],
expiry_year: [
    { value: "35", label: "2035" },
    { value: "34", label: "2034" },
    { value: "33", label: "2033" },
    { value: "32", label: "2032" },
    { value: "31", label: "2031" },
    { value: "30", label: "2030" },
    { value: "29", label: "2029" },
    { value: "28", label: "2028" },
    { value: "27", label: "2027" },
    { value: "26", label: "2026" },
    { value: "25", label: "2025" },
    { value: "24", label: "2024" },
    { value: "23", label: "2023" },
],
  supportRead: [
    { value: "yes", label: "yes" },
    { value: "no", label: "no" }
  ],
  devicePlatform: [
    { value: "ios", label: "ios" },
    { value: "android", label: "android" },
    { value: "web", label: "web" }
  ],
  isPhoneVerified: [
    { value: "true", label: "true" },
    { value: "false", label: "false" }
  ],
  notificationType: [
    { value: "billing", label: "billing" },
    { value: "payment", label: "payment" },
    { value: "complaint", label: "complaint" },
    { value: "chat", label: "chat" },
    { value: "general", label: "general" },
    { value: "report", label: "report" }
  ],
  reportType: [
    { value: "billing", label: "billing" },
    { value: "statement", label: "statement" }
  ],
  reportFileType: [
    { value: "jpg", label: "jpg" },
    { value: "png", label: "png" },
    { value: "jpeg", label: "jpeg" },
    { value: "gif", label: "gif" },
    { value: "pdf", label: "pdf" },
    { value: "excel", label: "excel" },
    { value: "word", label: "word" }
  ],

  exportFormats: {
    print: {
      label: 'Print',
      icon: 'pi pi-print',
      type: 'print',
      ext: 'print',
    },
    pdf: {
      label: 'Pdf',

      icon: 'pi pi-file-pdf',
      type: 'pdf',
      ext: 'pdf',
    },
    excel: {
      label: 'Excel',
      icon: 'pi pi-file-excel',
      type: 'excel',
      ext: 'xlsx',
    },
    csv: {
      label: 'Csv',
      icon: 'pi pi-table',
      type: 'csv',
      ext: 'csv',
    },
  },

}